import { useMemoizedFn } from 'ahooks'
import { Flex } from 'antd'

import { WpsClearFormatIcon } from '@eastcoal/icon/WpsClearFormatIcon'

import { useEditor } from '../../hooks/useEditor'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'
import { clearFormatting } from '../../utils/formatting'

export const ClearFormatButton = () => {
  const editor = useEditor()

  const handleClearFormat = useMemoizedFn(() => {
    clearFormatting(editor)
  })

  return (
    <MenuButton
      tooltip={
        <Flex vertical align='center'>
          <span>清除格式</span>
          <span>{SHORTCUTS.CLEAR_FORMATTING}</span>
        </Flex>
      }
      onClick={handleClearFormat}
    >
      <WpsClearFormatIcon />
    </MenuButton>
  )
}
